// Sources are created only when needed: a <source> without src in the markup fails resource selection at parse time.
const appendSources = (video) => {
    [['webmSrc', 'video/webm'], ['mp4Src', 'video/mp4']].forEach(([key, type]) => {
        if (!video.dataset[key]) return;

        const source = document.createElement('source');
        source.src = video.dataset[key];
        source.type = type;
        video.appendChild(source);
    });
};

export const videoLazyLoader = () => {
    const observeLazyVideos = () => {
        const lazyVideos = [...document.querySelectorAll('video.lazy-load')];

        if ('IntersectionObserver' in window) {
            const lazyVideoObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (video) {
                    if (video.isIntersecting) {
                        for (const source in video.target.children) {
                            const videoSource = video.target.children[source];
                            if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                                videoSource.src = videoSource.dataset.src;
                            }
                        }
                        appendSources(video.target);

                        if (video.target.dataset.poster) {
                            video.target.poster = video.target.dataset.poster;
                        }

                        try {
                            video.target.load();
                        } catch {
                            // Do nothing
                        }
                        video.target.classList.remove('lazy-load');
                        lazyVideoObserver.unobserve(video.target);
                    }
                });
            });

            lazyVideos.forEach(function (lazyVideo) {
                lazyVideoObserver.observe(lazyVideo);
            });
        } else {
            lazyVideos.forEach(function (video) {
                for (const source in video.children) {
                    const videoSource = video.children[source];
                    if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                        videoSource.src = videoSource.dataset.src;
                    }
                }
                appendSources(video);

                video.load();
                video.classList.remove('lazy-load');
            });
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observeLazyVideos);
    } else {
        observeLazyVideos();
    }
};
